<template>
  <div class="is-flex-column">
    <validated-input
      label="Account Tags"
      hide-label
      rules="required"
      name="accountTags"
      class="mar-b"
    >
      <b-dropdown
        :value="value"
        position="is-top-right"
        expanded
        max-height="436"
        class="has-extra-shadow"
        scrollable
        multiple
        @input="handleSelectTag"
      >
        <dropdown-button
          slot="trigger"
          placeholder="Select Account Tag(s)"
        />

        <b-dropdown-item
          aria-role="listitem"
          :class="{ 'is-active': value.length === accountTags.length }"
          @click="toggleAllTagsSelect"
        >
          All Tags
        </b-dropdown-item>

        <hr class="dropdown-divider">

        <b-dropdown-item
          v-for="tag in accountTags"
          :key="tag.id"
          :value="tag.id"
          aria-role="listitem"
        >
          {{ tag.name }}
        </b-dropdown-item>
      </b-dropdown>
    </validated-input>
    <b-taglist class="dist-x-sm is-flex-wrap">
      <b-tag
        v-for="tagId in value"
        :key="`tag${tagId}`"
        ellipsis
        closable
        attached
        size="is-medium"
        type="is-primary"
        close-type="is-primary"
        class="mar-none"
        @close="removeTag(tagId)"
      >
        <span class="has-text-weight-bold">{{ getUserTagName(tagId) }}</span>
      </b-tag>
    </b-taglist>
  </div>
</template>

<script>
  import UserAttribute from '@/store/classes/UserAttribute';

  export default {
    name: 'AccountTagsForm',

    props: {
      value: {
        type: Array,
        required: true
      }
    },

    data: () => ({}),

    computed: {
      accountTags() {
        return UserAttribute.all();
      },

      selectedTagsDisplay() {
        if (this.value.length === 1) {
          return UserAttribute.find(this.value[0]).name;
        }
        else if (this.value.length === this.accountTags.length) {
          return 'All Statuses';
        }
        else if (this.value.length > 1) {
          return `Selected (${this.value.length})`;
        }
        else {
          return '';
        }
      }
    },

    async created() {
      await this.onCreated();
    },

    methods: {
      async onCreated() {
        await this.fetchUserAttributes();
        // this.selectedTags = [...this.value];
      },

      async fetchUserAttributes() {
        try {
          await UserAttribute.fetchAttributes();
        }
        catch (error) {
          this.$_onRequestError({
            error,
            toastOptions: {
              message: 'There was an error fetching user attributes'
            }
          });
        }
      },

      toggleAllTagsSelect() {
        const updatedTags = this.value.length === this.accountTags.length
          ? []
          : this.accountTags.map(accountTag => accountTag.id);

        this.$emit('input', updatedTags);
      },

      findTag(tag) {
        return this.value.find(selectedTag => selectedTag.name.toLowerCase() === tag.name.toLowerCase());
      },

      handleSelectTag(tags) {
        this.$emit('input', tags);
      },

      removeTag(tagIdToRemove) {
        const updatedTags = this.value.filter(tagId => tagId !== tagIdToRemove);
        this.$emit('input', updatedTags);
      },

      getUserTagName(tagId) {
        return UserAttribute.find(tagId)?.name;
      }
    }
  };
</script>

<style lang="sass" scoped>
  .tags
    max-width: 900px
</style>
